import React from 'react';

const AnalysisStatusSection = ({ processingMessage }) => {
  return (
    <div className="processing-status">
      <div className="loading-spinner-container">
        <div className="loading-spinner"></div>
      </div>
      <p className="processing-message" style={{ fontSize: '16px', marginTop: '15px' }}>
        {processingMessage || 'Analyzing video...'}
      </p>
      <p style={{ fontSize: '14px', color: '#999', marginTop: '8px' }}>
        This may take 30-60 seconds depending on video length
      </p>
    </div>
  );
};

export default AnalysisStatusSection;
